<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
  >
  </WsCreate>
</template>
<script>
import model from "@/models/exit_check_item_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "收工檢查項目資訊",
              fields: ["locales", "remark"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "area",
                "area_section",
                // "system_class",
                // "system_subclasses",
                "industry_categories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "顯示設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
};
</script>